export default { type: "separator" as const };
